module.exports = __webpack_public_path__ + "static/media/earhear-4.5aea16f6.png";